module.exports = __webpack_public_path__ + "img/CATEGORY ICON-29.81d27dfc.png";